import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StorageInjectionToken } from '@fleet-beat/libs-core/src/lib/injection-tokens/storage.injection-token';
import { CoreDirectivesModule } from './directives/core-directives.module';
import { IconsModule } from './icons';
import { EnvironmentCheckModule } from './modules/environment-check/environment-check.module';
import { LoaderModule } from './modules/loader/loader.module';
import { SnackbarModule } from './modules/snackbar/snackbar.module';
import { CorePipesModule } from './pipes/core-pipes.module';

@NgModule({
  imports: [CommonModule],
  exports: [
    CommonModule,
    CoreDirectivesModule,
    CorePipesModule,
    LoaderModule,
    SnackbarModule,
    EnvironmentCheckModule,
    IconsModule,
  ],
  providers: [{ provide: StorageInjectionToken, useValue: localStorage }],
})
export class FbCoreModule {}
